import { CrossSectionCanvas } from '@pages/cross-section/shared/CrossSectionCanvas';
import Konva from 'konva';


function drawAlignment(opts: {
    alignment: any,
    isBackground: boolean,
    csCanvas: CrossSectionCanvas,
    onClickCallback: (logpoint, x, y) => void
}) {
    const { alignment, isBackground, csCanvas, onClickCallback } = opts;
    const canvasOptions = csCanvas.canvasOptions;
    const lowestPoint = csCanvas.lowestPoint;
    const layer = csCanvas.contentLayer;
    const size = isBackground ? 12 : 20;
    let center = csCanvas.getCenter();

    const x = center + alignment.point.x * canvasOptions.x_scale;
    const y = ((csCanvas.height - canvasOptions.bottom_margin) + lowestPoint * canvasOptions.y_scale - alignment.point.y * canvasOptions.y_scale) + csCanvas.panY;
    const unit = kuura.getUnit().abbr;

    const poly = new Konva.Line({
        points: [x, y, x - (size / 2), y - size, x + (size / 2), y - size],
        stroke: getRgb(alignment.color),
        strokeWidth: 1,
        closed: true,
        listening: false
    });
    let text = new Konva.Text({
        x: x,
        y: y - (size + 5),
        text: "      z:  " + alignment.point.y.toFixed(2) + ' ' + unit,
        fontSize: size,
        fontFamily: 'Calibri',
        fill: getRgb(alignment.color)
    });
    let text2 = new Konva.Text({
        x: x,
        y: y - (size + 16),
        text: 'Station:  ' + alignment.intersectionStation.toFixed(2) + ' ' + unit,
        fontSize: size,
        fontFamily: 'Calibri',
        fill: getRgb(alignment.color),
    });
    let hoverShape = new Konva.Rect({
        x: x - (size / 2),
        y: y - size,
        width: size,
        height: size,
        stroke: 'transparent'
    });
    hoverShape.on('click tap', () => onClickCallback(alignment.point, x, y));
    text.on('click tap', () => onClickCallback(alignment.point, x, y));

    hoverShape.on('mouseover', () => showTooltip(alignment, x, y, size, csCanvas.tooltipLayer));
    text.on('mouseover', () => showTooltip(alignment, x, y, size, csCanvas.tooltipLayer));

    hoverShape.on('mouseout', csCanvas.clearHoverTooltips);
    text.on('mouseout', csCanvas.clearHoverTooltips);

    layer.add(hoverShape);

    text.offsetX(text.width() / 2);
    text.offsetY(text.height());
    text2.offsetX(text2.width() / 2);
    text2.offsetY(text2.height());

    layer.add(poly);
    layer.add(text);
    if (isBackground) {
        layer.add(text2);
    }
}

const showTooltip = (alignment: any, x: number, y: number, size: number, layer: Konva.Layer) => {
    if (!alignment) {
        return
    }
    let t = (alignment.name ?? alignment.id) + '\n' + kuura.getMessage('js.cross_section.b') + ': ' + alignment.point.x.toFixed(2);

    const rect = new Konva.Rect({
        x: x - size - 4,
        y: y - size - size - 5,
        width: size * 2 + 8,
        height: size * 2 + 8,
        stroke: 'gray',
        strokeWidth: 1,
        listening: false
    });
    const text = new Konva.Text({
        name: 'alignment_hover_text',
        x: x,
        y: y - size - size - 8,
        text: t,
        fontSize: 12,
        fontFamily: 'Calibri',
        fill: 'black',
        listening: false
    });
    text.offsetX(text.width() / 2);
    text.offsetY(text.height());

    const boxw = text.width() + 10;
    const boxh = text.height();
    const box = new Konva.Rect({
        x: x - boxw / 2,
        y: y - size - size - 8 - text.offsetY(),
        width: boxw,
        height: boxh,
        fill: 'rgba(255,255,255,128)',
        opacity: 0.5,
        listening: false
    });

    layer.add(rect);
    layer.add(box);
    layer.add(text);
    layer.draw();
}

const getRgb = (color: string) => 'rgb(' + color + ')'

export const CrossSectionAlignment = {
    drawAlignment
}
